import { useCallback, useState } from 'react';
import { useBackgroundJobRun } from '@molecules/BackgroundJobWait/useBackgroundJobRun';
import type { LoadFromFileTransport } from './loadFromFileTransport';

export interface IUseLoadFromFileFlowOptions {
    transport: LoadFromFileTransport;
    /**
     * Итог — в окне, файл результата — по кнопке в нём. Без итога в окне успех закрывает окно, ошибка — плашкой над
     * выбором файла, а файл результата скачивается сразу.
     */
    showResult: boolean;
    /** Текст успеха вместо сообщения сервера. */
    successText?: string;
    onComplete?: (isSucceed: boolean) => void;
}

/** Окно ожидания (`useBackgroundJobRun`) для загрузки файла: `idle` — выбор файла, `start` — загрузить его. */
export const useLoadFromFileFlow = ({
    transport,
    showResult,
    successText,
    onComplete,
}: IUseLoadFromFileFlowOptions) => {
    const [fileName, setFileName] = useState('');
    const run = useBackgroundJobRun({ kind: 'loadFromFile', showResult, successText, onComplete });
    const { startTask } = run;

    const start = useCallback(
        (file: File) => {
            setFileName(file.name);
            startTask((context) => transport(file, context));
        },
        [startTask, transport],
    );

    return { ...run, fileName, start };
};
